import { SelectItem } from '../../types';

export const ACTION = {
  CLEAR_DISTRIBUTION_STATE: 'SELECTION_REPORT:CLEAR_DISTRIBUTION_STATE',
  REQUEST_DISTRIBUTION_FIELDS: 'SELECTION_REPORT:REQUEST_DISTRIBUTION_FIELDS',
  RESPONSE_DISTRIBUTION_FIELDS: 'SELECTION_REPORT:RESPONSE_DISTRIBUTION_FIELDS',
  REQUEST_METADATA: 'SELECTION_REPORT:REQUEST_METADATA',
  RESPONSE_METADATA: 'SELECTION_REPORT:RESPONSE_METADATA',
  REQUEST_DISTRIBUTION_DEFAULT_FIELDS: 'SELECTION_REPORT:REQUEST_DISTRIBUTION_DEFAULT_FIELDS',
  RESPONSE_DISTRIBUTION_DEFAULT_FIELDS: 'SELECTION_REPORT:RESPONSE_DISTRIBUTION_DEFAULT_FIELDS',
  UPDATE_DEFAULT_DISTRIBUTION_FIELDS: 'SELECTION_REPORT:UPDATE_DEFAULT_DISTRIBUTION_FIELDS'
};

export class ClearDistributionState {
  public type: string = ACTION.CLEAR_DISTRIBUTION_STATE;
  constructor(public instanceKey: string) {}
} 
export class RequestDistributionDefaultFields {
  public type: string = ACTION.REQUEST_DISTRIBUTION_DEFAULT_FIELDS;
  constructor(public instanceKey: string) {}
}
export class ResponseDistributionDefaultFields {
  public type: string = ACTION.RESPONSE_DISTRIBUTION_DEFAULT_FIELDS;
  constructor(public instanceKey: string, public options: SelectItem[]) { }
}
export class RequestMetadata {
  public type: string = ACTION.REQUEST_METADATA;
  constructor(public instanceKey: string) {}
}
export class ResponseMetadata {
  public type: string = ACTION.RESPONSE_METADATA;
  constructor(public instanceKey: string, public options: SelectItem[]) { }
}
export class UpdateDistributionDefaultFields {
  public type: string = ACTION.UPDATE_DEFAULT_DISTRIBUTION_FIELDS;
  constructor(public instanceKey: string, public options: SelectItem[]) { }
}
export class ResponseDistributionFields {
  public type: string = ACTION.RESPONSE_DISTRIBUTION_FIELDS;
  constructor(public instanceKey: string, public options: SelectItem[]) { }
}
